<template>
  <div class="my-notice-list">
    <div class="notice-item" v-for="(item, index) in list" :key="index" @click="goInfo(item.jump, item.parameter)">
      <div class="notice">
        <div class="title">{{item.title}}<span class="time">{{item.noticeTime}}</span></div>
        <div class="content">
          {{item.messageContent}}
        </div>
        <div class="action">查看详情<span class="icon"><van-icon name="arrow" size="20px" color="#999999" /></span></div>
      </div>
    </div>
  </div>
</template>

<script>
import { openApp } from '@/utils'

export default {
  props: {
    list: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  methods: {
    goInfo (type, id) {
      switch(type) {
        case 37: //订单详情
          this.$router.push({ path: '/order/detail/' + id })
          break;
        case 13: //我的钱包
          this.$dialog.confirm({
            title: '提示',
            message: '下载胖虎奢侈品APP查看我的钱包',
            confirmButtonText: '去下载'
          }).then(() => {
            openApp('ponhu://');
          }).catch(() => {
          })
          break;
        case 40: //鉴定详情
          location.href = process.env.VUE_APP_APPRASISER_URL + 'community/detail/' + id
          break;
        default:
          break;
      }
    }
  }
}
</script>

<style lang="less" scoped>
.my-notice-list {
  .notice-item {
    margin: 30px;
    display:-webkit-box;
    display:-webkit-flex;
    position:relative;
    background: #ffffff;
    box-shadow:0px 10px 20px 0px rgba(0,0,0,0.1);
    border-radius:10px;
    .notice {
      padding: 30px 24px;
      .title {
        font-size:28px;
        font-weight:500;
        color:#333333;
        line-height:40px;
        width: 75%;
        display: flex;
      }
      .time {
        flex: 1;
        font-size:20px;
        position:absolute;
        right:30px;
        font-weight:500;
        color: #CCCCCC;
      }
      .content {
        font-size:24px;
        font-weight:400;
        color:#999999;
        line-height:32px;
        padding: 10px 0 20px;
        border-bottom: 1px solid #eeeeee;
      }
      .action {
        font-size:24px;
        font-weight:400;
        color:#999999;
        padding-top: 24px;
      }
      .icon {
        flex: 1;
        position:absolute;
        right: 10px;
      }
    }
  }
}
</style>
